// JOBE-0158.3: PillChip — neutral filter chip.
// With onClick: renders as <button> with hover-lift to --paper-3.
// Without onClick: renders as <span>, no hover state.
// No status color — ink-soft text, paper-2 background, rule-2 border.
// JOBE-0163.1: added `active` prop for framing-picker selected state.

import './PillChip.css';

/**
 * @param {object} props
 * @param {string} props.label
 * @param {boolean} [props.active] — whether the chip is the currently selected item
 * @param {Function} [props.onClick]
 */
export function PillChip({ label, active = false, onClick }) {
  const Tag = onClick ? 'button' : 'span';
  return (
    <Tag
      className={[
        'pill-chip',
        onClick ? 'pill-chip--interactive' : '',
        active   ? 'pill-chip--active'      : '',
      ].filter(Boolean).join(' ')}
      onClick={onClick}
      type={onClick ? 'button' : undefined}
      aria-pressed={onClick ? active : undefined}
    >
      {label}
    </Tag>
  );
}
